// extracted by mini-css-extract-plugin
export default {"container":"XfcI","checkbox-container":"QLfQ","checkboxContainer":"QLfQ","checkbox":"Tw9g","input":"ACBU"};